<script lang="ts">
  import { cx } from '@emotion/css';
  import { ResponsiveVars, TwistBox } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import MobileFilters from './Filters/MobileFilters.svelte';
  import DesktopFilters from './Filters/DesktopFilters.svelte';
  import type { JobFilters } from '$lib/careers/types';
  import Container from '$components/News/Container.svelte';

  export let values: JobFilters;

  const responsiveVars = new ResponsiveVars()
    .addFluid('contents-py', toFluidVarInput(15, 15))
    .addFluid('search-font-size', toFluidVarInput(18, 18))
    .toCSS();
</script>

<div class={cx(responsiveVars, 'filters-bar')} id="jobs-list-filters">
  <Container>
    <TwistBox paddingY={toFluidVarInput(15, 15)}>
      <MobileFilters {values} on:filters-change />
      <DesktopFilters {values} on:filters-change />
    </TwistBox>
  </Container>
</div>

<style lang="scss">
  @import 'src/scss/variables';
  @import 'src/scss/media';

  .filters-bar {
    width: 100%;
    position: sticky;
    top: 0;
    z-index: map-get($zIndex, primary-nav);
    background: rgba(221, 221, 221, 0.46);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }

  .divider {
    opacity: 30%;
  }
</style>
